import script from "./TranslatorMyOffers.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorMyOffers.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorMyOffers.vue?vue&type=style&index=0&id=504a5453&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-504a5453"]])

export default __exports__